import { render } from "./Mirabella.vue?vue&type=template&id=67e2ded4&ts=true"
import script from "./Mirabella.vue?vue&type=script&lang=ts"
export * from "./Mirabella.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__